export default "__VITE_ASSET__zVFzXdKk__"